import {connect} from 'react-redux'
// import {push} from 'connected-react-router'
import {
    licenceHistoryDetailsSelect,
    populateLicenceHistoryListQuestionForReview,
    populateLicenceHistoryListDataForReview
} from '../../redux/selector/licenceDetailsSelector'

// import {setLicenceHistoryDetails} from '../../redux/slice/collectionApplicationSlice'
// import {setCollectorLicenceHistoryDetails} from '../../redux/slice/collectorApplicationSlice'
import {
    Header, 
    Paragraph, 
    Button,
    NavigationLinkButton,
    LineSeperator,
} from '../../components/RegularComponents'
import ReviewForm from '../../components/ReviewForm/ReviewForm'
import TopNavigationBar from "../TopNavigationBar"
import { useState } from 'react'
import HistoryDetailsForm from '../../components/LicenceDetails/LicenceHistoryDetails'
import {
    VIEW_MODE_REGULAR,
    APPLICATION_MODE_RENEW,
    APPLICATION_TYPE_COLLECTOR,
    VIEW_MODE_RENEWAL_PREVIEW,
    VIEW_MODE_RENEWAL_EDIT,
    VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT,
    APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT,
} from '../../app/constants'
// import { replaceUrlParams } from '../../app/utils';
import Navigation from '../Navigation'
// import { setAgencyLicenceHistoryDetails } from '../../redux/slice/primaryAgencyApplicationSlice'

const LicenceHistoryDetails = (props) => {
    
    // const {dispatch} = props
    const {applicationType, applicationMode} = props.match.params
    const collectorApplicantDetails = props.licenceHistoryDetails.collectorApplicantDetails
    const licenceHistoryDetails = props.licenceHistoryDetails[applicationType] ? 
        props.licenceHistoryDetails[applicationType] : props.licenceHistoryDetails

    const defaultHistoryDetailObject = () => {
        return {
            businessLicenceType : "",
            province : "",
            startDate : 0,
            endDate :0
        }
    }

    let details = []
    if(licenceHistoryDetails.licenceHistoryList &&
        Array.isArray(licenceHistoryDetails.licenceHistoryList)
        && licenceHistoryDetails.licenceHistoryList.length > 0 
    ) {
        details = licenceHistoryDetails.licenceHistoryList
    } else { 
        details.push(defaultHistoryDetailObject())
    }

    const [historyDetails, setHistoryDetails] = useState(details)

    const [viewMode,setViewMode] = useState(props.viewMode ? 
        props.viewMode : (applicationMode === APPLICATION_MODE_RENEW ? 
            VIEW_MODE_RENEWAL_PREVIEW : VIEW_MODE_REGULAR))

    const onNextClick =() => {
        // if(applicationType === APPLICATION_TYPE_COLLECTOR || 
        //     applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT) {
        //     dispatch(setCollectorLicenceHistoryDetails(historyDetails))
        // } else { 
        //     dispatch(setLicenceHistoryDetails(historyDetails))
        //     dispatch(setAgencyLicenceHistoryDetails(historyDetails))
        // }
        
        // let nextUrl = licenceHistoryDetails.navigation.next
        // if((viewMode === VIEW_MODE_RENEWAL_PREVIEW || viewMode === VIEW_MODE_RENEWAL_EDIT)
        //     && licenceHistoryDetails.navigation.nextRenewal) {
        //     nextUrl = licenceHistoryDetails.navigation.nextRenewal
        // }
        // dispatch(push(replaceUrlParams(nextUrl,applicationType, applicationMode)))
    }

    const onDetailsChange = (update) => {
        let index = parseInt(update.id)
        let updatedHistoryDetails = [...historyDetails]
        let updatedDetails = Object.assign({}, historyDetails[index], update.updatedDetails)
        updatedHistoryDetails.splice(index, 1,updatedDetails)
        setHistoryDetails(updatedHistoryDetails)
    }

    let historyComponents = []

    historyDetails.forEach((element, key) => {
        historyComponents.push(
            <div key={key} className="bottomMarginNormal">
                <div className={"bottomMarginNormal"}>
                    <HistoryDetailsForm 
                        id={key} 
                        onDetailsChange={onDetailsChange}
                        businessLicenceType={element.businessLicenceType}
                        province={element.province}
                        startDate={element.startDate}
                        endDate={element.endDate} 
                    />
                </div>
                <LineSeperator />
            </div>
        )
    });

    let reviewData = []
    if(viewMode === VIEW_MODE_RENEWAL_PREVIEW)
        reviewData = populateLicenceHistoryListDataForReview(details)

    let collectorName = "Collector"

    if(collectorApplicantDetails && collectorApplicantDetails.firstName) {
        collectorName = collectorApplicantDetails.firstName
    }

    let paragraphText = (viewMode === VIEW_MODE_RENEWAL_PREVIEW) ? 
        licenceHistoryDetails.textRenewal : licenceHistoryDetails.text
    if(applicationType === APPLICATION_TYPE_COLLECTOR || 
        applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT) {
        paragraphText = paragraphText.map((text) => text.replace("<collector_name>",collectorName))
    }

    return(
        <>
            {viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT && 
            <Navigation {...props} /> }
            <div className={viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT ? "container" : ""}>
                {VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT !== viewMode &&
                <>
                    <TopNavigationBar {...props} />
                    <div className="row">
                        <div className={"col-lg-8"}>
                            <Header 
                                id="licence-history-details-header" 
                                header={viewMode === VIEW_MODE_RENEWAL_PREVIEW ? 
                                        licenceHistoryDetails.headerRenewal : licenceHistoryDetails.header} />
                            <Paragraph 
                                id="licence-history-details-text"
                                text={paragraphText} />
                        </div>
                    </div>
                </>
                }
                <div className={"row"}>
                    <div className={"col-lg-12"}>
                        {viewMode === VIEW_MODE_RENEWAL_PREVIEW &&
                        <>
                            <ReviewForm data={populateLicenceHistoryListQuestionForReview(details)} />
                            {
                                reviewData.map((elsewhereData, index) => {
                                    return (
                                        <div key={"review-licence-history-data-" + index}>
                                            <ReviewForm data={elsewhereData} />
                                            {(index < reviewData.length - 1)
                                                && <LineSeperator />} 
                                        </div>
                                    )
                                })
                            }
                        </>
                        }
                        {viewMode !== VIEW_MODE_RENEWAL_PREVIEW &&
                            historyComponents
                        }
                    </div>
                </div>

                {viewMode !== VIEW_MODE_RENEWAL_PREVIEW && 
                    <div className="row bottomMarginMedium">
                        <div className={"col-lg-8"}>
                            <NavigationLinkButton
                                id={"licencey-history-add-more-link"}
                                text={"+ Add a licence history"}
                                onClick={() => {
                                    let historyDetailUpdate = [...historyDetails, defaultHistoryDetailObject()]
                                    setHistoryDetails(historyDetailUpdate)
                                }}
                            />
                        </div>
                    </div>
                }

                {VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT !== viewMode &&
                    <div className="row bottomMarginNormal">
                        <div className={"col-lg-4"}>
                            <Button 
                                id="preview-before-submit-next"
                                text={"Next"}
                                buttonType={"regular_primary"}
                                onClick={onNextClick}
                            />
                        </div>
                        {viewMode === VIEW_MODE_RENEWAL_PREVIEW && 
                        <div className="col-lg-4">
                            <NavigationLinkButton 
                                id={"licence-history-details-edit-mode-switch"}
                                text={"Update this information before continuing"}
                                onClick={() => { setViewMode(VIEW_MODE_RENEWAL_EDIT)}}
                            />
                        </div>}
                    </div>
                }
                {VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT === viewMode &&
                    <div className="row bottomMarginNormal">
                        <div className={"col-lg-8"}>
                            <Button 
                                id="preview-before-submit-save"
                                text={"Save"}
                                buttonType={"regular_primary"}
                                onClick={() => {
                                    // if(applicationType === APPLICATION_TYPE_COLLECTOR || 
                                    //     applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT) {
                                    //     dispatch(setCollectorLicenceHistoryDetails(historyDetails))
                                    // } else { 
                                    //     dispatch(setLicenceHistoryDetails(historyDetails))
                                    //     dispatch(setAgencyLicenceHistoryDetails(historyDetails))
                                    // }
                                    // props.onEditSave()
                                }}
                            />
                        </div>
                    </div>
                }
            </div>
        </>
    )
}

export default connect(licenceHistoryDetailsSelect)(LicenceHistoryDetails)
